import constants from './constants';

const { socialSharing } = constants;

class SocialSharing {
    [socialSharing.TWITTER.name] ({ url, title }) {
        return `https://twitter.com/intent/tweet/?url=${url}&text=${title}`
    }

    [socialSharing.FACEBOOK.name] ({ url, title }) {
        return `https://www.facebook.com/sharer/sharer.php?u=${url}&title=${title}`
    }

    [socialSharing.WHATS_APP.name] ({ url }) {
        return `https://wa.me/?text=${url}`
    }

    [socialSharing.EMAIL.name] ({ url, title, text }) {
        return `mailto:?subject=${title}&body=${url}${text ? '\\n' + text : ''}`
    }

    [socialSharing.REDDIT.name] ({ url, title }) {
        return `https://reddit.com/submit?url=${url}&title=${title}`
    }

    [socialSharing.LINKEDIN.name] ({ url, title, text }) {
        return `https://www.linkedin.com/shareArticle?mini=true&url=${url}&title=${title}&summary=${text}`
    }

    [socialSharing.PINTEREST.name] ({ url }) {
        return `http://pinterest.com/pin/create/link/?url=${url}`
    }

    [socialSharing.SKYPE.name] ({ url, title }) {
        return `https://web.skype.com/share?url=${url}&text=${title}`
    }

    [socialSharing.EVERNOTE.name] ({ url, title }) {
        return `https://www.evernote.com/clip.action?url=${url}&title=${title}`
    }

    [socialSharing.TUMBLR.name] ({ url, title, text }) {
        return `https://www.tumblr.com/widgets/share/tool?canonicalUrl=${url}&title=${title}&caption=${text}&tags=`
    }

    [socialSharing.DIGG.name] ({ url }) {
        return `https://www.digg.com/submit?url=${url}`
    }

    [socialSharing.STUMBLEUPON.name] ({ url }) {
        return `https://mix.com/mixit?su=submit&url=${url}`
    }

    [socialSharing.FLIPBOARD.name] ({ url, title }) {
        return `https://share.flipboard.com/bookmarklet/popout?v=2&title=${title}&url=${url}`
    }

    [socialSharing.RENREN.name] ({ url }) {
        return `http://share.renren.com/share/buttonshare?link=${url}`
    }

    [socialSharing.VIBER.name] ({ url }) {
        return `viber://forward?text=${url}`
    }

    [socialSharing.GOOGLE_BOOKMARKS.name] ({ url, title, text }) {
        return `https://www.google.com/bookmarks/mark?op=edit&bkmk=${url}&title=${title}&annotation=${text}&labels=`
    }

    [socialSharing.HACKERNEWS.name] ({ url, title }) {
        return `https://news.ycombinator.com/submitlink?u=${url}&t=${title}`
    }

    [socialSharing.BUFFER.name] ({ url, title }) {
        return `https://buffer.com/add?url=${url}&title=${title}`
    }

    [socialSharing.WEIBO.name] ({ url, title }) {
        return `http://service.weibo.com/share/share.php?url=${url}&title=${title}&pic=:image`
    }

    [socialSharing.TELEGRAM.name] ({ url, title }) {
        return `https://telegram.me/share/url?url=${url}&text=${title}`
    }

    [socialSharing.LINE.name] ({ url, title }) {
        return `https://lineit.line.me/share/ui?url=${url}&text=${title}`
    }

    [socialSharing.KAKAO.name] ({ url }) {
        return `https://story.kakao.com/s/share?url=${url}`
    }
}

export default new SocialSharing();
